import { handleRequest } from "../utilities/requestHandler";

export const getMachinesByIds = (req_body) => 
    handleRequest("post", "/machines/by-ids", req_body);

export const getSingleProduct = (req_body) => 
    handleRequest("post", "/products/getsingle", req_body);

export const getOrderByKey = (req_body) => 
    handleRequest("post", "/orders/getOrderByKey", req_body);